import client from "../api-client";
import toQueryString from "../toQueryString";

const URL = "graphs.php";

export const get = async (type, period) => {
  let params = toQueryString({ type: type, period: period });
  return await client(URL + `?${params}`);
};
